export interface ShouldBeVisibleParams {
  featureFlags?: Array<string>;
  roles?: Array<string>;
  actualFeatureFlags?: Record<string, boolean>;
  actualRoles?: Array<string>;
  excludedRoles?: Array<string>;
  excludedFeatureFlags?: Array<string>;
  requiredFeatureFlags?: Array<string>;
  customCheck?: (actualRoles: string[]) => boolean;
}

export const PARAMS_MAP_KEY = 'paramsMap';
export const MORE_MENU_KEY = 'More';

export const shouldBeVisible = ({
  featureFlags,
  roles,
  actualFeatureFlags,
  actualRoles,
  excludedRoles,
  excludedFeatureFlags,
  requiredFeatureFlags,
  customCheck
}: ShouldBeVisibleParams): boolean => {
  // check if custom check is provided
  if (customCheck && actualRoles) {
    if (customCheck(actualRoles)) return false;
  }

  // check if any excluded conditions are met
  if (Array.isArray(excludedRoles) && actualRoles) {
    const hasExcludedRole = excludedRoles.some(role => actualRoles.includes(role));
    if (hasExcludedRole) return false;
  }

  if (Array.isArray(excludedFeatureFlags) && actualFeatureFlags) {
    const hasExcludedFeature = excludedFeatureFlags.some(feature => actualFeatureFlags[feature]);
    if (hasExcludedFeature) return false;
  }

  // check if all required feature flags are enabled
  if (Array.isArray(requiredFeatureFlags) && actualFeatureFlags) {
    const allRequiredFlagsPresent = requiredFeatureFlags.every(flag => actualFeatureFlags[flag]);
    return allRequiredFlagsPresent;
  }

  // check for inclusion conditions
  if (Array.isArray(featureFlags) && actualFeatureFlags) {
    const resultOfFeatureFlags = featureFlags.some(feature => actualFeatureFlags[feature]);
    if (resultOfFeatureFlags) return true;
  }

  if (Array.isArray(roles) && actualRoles) {
    const resultOfRoles = roles.some(role => actualRoles.includes(role));
    if (resultOfRoles) return true;
  }

  return false;
};
